import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getTranslationJson, getTranslationLatestUpdateTime } from '../api/frontendgql';
import { createTranslationService } from './translation';

const i18n = i18next.createInstance();
i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    resources: {},
    initImmediate: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false, bindI18nStore: 'added removed' },
});

export const translationService = createTranslationService({
    engine: i18n,
    getJson: getTranslationJson,
    getLatest: getTranslationLatestUpdateTime,
});

export default i18n;
